import React from 'react';
import {connect} from 'react-redux';
import {Icon} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {I18n} from 'react-redux-i18n';

import DVRSnapshot from './DVRSnapshot';
import DVRSnapshotsInfoMessage from './DVRSnapshotsInfoMessage';
import {getSnapshots, getCachedSnapshots} from '../DVRSnapshotsActions';
import { CAMERA_VIEWS } from './../../app/configuration/cameras';
import { find, sortBy } from 'lodash';

class DVRSnapshots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingSnapshots: false,
      snapshots: {
        channels: this.getSnapShotChannels(props.machineType)
      }
    };
  }

  getSnapShotChannels = (machineType) => {
    const channels = [];
    try {
      const availableChannels = CAMERA_VIEWS.get(machineType);
      const availableChannels_sorted = sortBy(availableChannels, c => c.formOrder);
      availableChannels_sorted && Object.keys(availableChannels_sorted).forEach((channelKey) => {
        const channel = availableChannels_sorted[channelKey];
        channel.name = channel.detailskey;
        channels.push(channel);
      })  
    } catch (error) {
      console.log(`Error in retrieving channels in DVRSnapshots - ${error}`);
    }
    return channels;
  }

  componentDidMount() {
    const {serialNumber, machineType} = this.props;

    this.props.getCachedSnapshots({serialNumber, machineType});
  }

  componentWillReceiveProps(nextProps) {
    let {isLoadingSnapshots, snapshots, machineType} = nextProps;
    if(snapshots && snapshots.channels && snapshots.channels.length === 0){
      snapshots.channels = this.getSnapShotChannels(machineType);
    }
    this.setState({
      isLoadingSnapshots,
      snapshots
    });
  }

  handleGetSnapshots = () => {
    const {serialNumber, machineType} = this.props;

    this.props.getSnapshots({serialNumber, machineType});
  }

  handleButtonIcon = () => {
    if (this.state.isLoadingSnapshots) {
      return (<CircularProgress className="availablevideo__loading" />);
    }
    return (<Icon className="availablevideo__cameicon">videocam</Icon>);
  }

  renderSnapshots = () => {
    const {machineType, dvrChannels} = this.props;
    return this
      .state
      .snapshots
      .channels
      .filter(channel => {
        const dvrChannel = find(dvrChannels, {id: channel.id});
        if(dvrChannel && dvrChannel.hasOwnProperty('enabled')){
          channel.isEnabled = dvrChannel.enabled;
        }
        if (machineType === 1) {
          return (channel.name === 'forwardFacing' || channel.name === 'rear');
        }
        return true;
      }).map(channel => (
        <DVRSnapshot
          id={`${channel.name}Snapshot`}
          key={channel.name}
          channel={channel}
        />
      ));
  }

  render() {
    return (
      <div>
        <div className="dvrcard__cameracont">
          {this.renderSnapshots()}

          <DVRSnapshotsInfoMessage id="snapshotInfoMessage" />

          <div className="dvrcard__cameraaction">
            <Button
              id="getSnapshots"
              variant="contained"
              color="default"
              className="btn btn-terciery"
              disabled={this.state.isLoadingSnapshots}
              onClick={this.handleGetSnapshots}
            >
              {this.handleButtonIcon()}

              {I18n.t('page.dvrsnapshots.testCameras')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {dvrSnapshots} = state;

  return dvrSnapshots;
};

export default connect(mapStateToProps, {getSnapshots, getCachedSnapshots})(DVRSnapshots);
